import { reduxForm } from 'redux-form'
import at from 'lodash/at'
import get from 'lodash/get'

import { goBack } from 'react-router-redux'
import { setSortingForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerFilterModal from '../../components/work-trackers/work-tracker-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  const resources = [
    { id: 'desc', name: 'Most Recent' },
    { id: 'asc', name: 'Last' }
  ]

  return {
    resourceName: 'sorting',
    modalTitle: 'Choose a Sorting Option',
    hasNextPage: false,
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.sortingId`)
    },
    resources
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      dispatch(setSortingForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'workTrackerSortingfilter'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-sorting-container.js